import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { toast } from 'react-toastify';

import * as Yup from 'yup';
import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { isNull, isArray, concat, trim } from 'lodash';

import api from '~/services/api';
import { t, parseDateString } from '~/helpers';
import { Report } from '~/components';
import { DateTime, Autocomplete, RadioGroup, Select } from '~/components/Form';

function Reloperstatusterminais() {
  const [open, setOpen] = useState(true);
  const [post, setPost] = useState({
    poco_desc_abrev: null,
    poco_codigo: null,
  });
  const [terminals, setTerminals] = useState([]);
  const [terminalstr, setTerminalstr] = useState('');

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const onSerializeData = useCallback(
    (data) => {
      if (data.terminal == 'Todos') {
        data.terminal = '';
      }
      return {
        ...data,
        terminalstr:
          terminalstr == 'Todos'
            ? ''
            : terminals.find((value) => value.value === terminalstr).label,
        posto: post.poco_codigo,
        postostr: post.poco_descricao,
      };
    },
    [terminalstr, post]
  );

  const handleValidate = useCallback(
    async (data) => {
      try {
        if (isNull(post.poco_codigo) || !terminalstr) {
          delete data.terminal;
        }

        const schema = Yup.object().shape({
          // datahorainicial: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
          // datahorafinal: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
          datahorainicial: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
          datahorafinal: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(
              datahorafinal,
              `A data não pode ser superior a ${datahorafinal}`
            )
            .min(
              Yup.ref('datahorainicial'),
              'A data não pode ser inferior a Data inicial'
            ),
          posto: Yup.string()
            .nullable()
            .required(t('s.geral.validacao.campoobrigatorio')),
          terminal: Yup.string()
            .nullable()
            .required(t('s.geral.validacao.campoobrigatorio')),
        });

        await schema.validate(data, {
          abortEarly: false,
        });
      } catch (err) {
        const form = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            form[error.path] = error.message.replace(`${error.path} `, '');
          });

          throw { form };
        }
      }
    },
    [post, terminalstr]
  );

  const handleGetTerminals = useCallback(async () => {
    try {
      const { data } = await api.get('terminal', {
        params: {
          wherefield: 'poco_codigo',
          valuewherefield: post.poco_codigo,
          typewherefield: 'EQUALS',
          pesquisalista: true,
        },
      });

      setTerminals(
        concat(
          [{ label: 'TODOS', value: 'Todos' }],
          data.items.map((item) => ({
            label: `${item.term_identificacao} - ${item.term_ip}`,
            value: item.term_identificacao,
          }))
        )
      );
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [post]);

  useEffect(() => {
    if (!isNull(post.poco_codigo)) handleGetTerminals();
    else {
      setTerminals([]);
      setTerminalstr('');
    }
  }, [post]);

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Status de Comunicação dos Terminais"
      relatorio="saldostatusterminaispostoperiodo"
      serialize={(param) => onSerializeData(param)}
      validate={handleValidate}
      initials={{
        datahorainicial,
        datahorafinal,
        tipo: 'pdf',
      }}
    >
      {/* <DateTime time label="Data Inicial" name="datahorainicial" />
      <DateTime time label="Data Final" name="datahorafinal" /> */}

      <DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture={true}
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture={true}
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="posto"
        label="poco_desc_abrev"
        title="Posto"
        url="postoscomboios"
        unique="poco_codigo"
        getValue={(value) => setPost(value)}
        onInputChange={() => terminalstr !== 'Todos' && setTerminalstr('')}
      />

      <Select
        name="terminal"
        label="Terminal"
        options={terminals}
        getValue={(value) => setTerminalstr(trim(value) || 'Todos')}
        disabled={isNull(post.poco_codigo)}
      />

      <RadioGroup
        row
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
      />
    </Report>
  );
}

export default Reloperstatusterminais;
